import { Routes } from '@angular/router';
import { AlteGrundbuchmeldungSucheComponent } from './alte-grundbuchmeldung-suche/alte-grundbuchmeldung-suche.component';
import { canActivateErweiterung } from '../../security/erweiterung.guard';
import { AlteGrundbuchmeldungListComponent } from './alte-grundbuchmeldung-list/alte-grundbuchmeldung-list.component';
import { canActivateAuthorization } from '../../security/authorization.guard';
import { PermissionResponse } from '../../core/base-api';
import { AlteGrundbuchmeldungListResolver } from './alte-grundbuchmeldung-list/alte-grundbuchmeldung-list-resolver';
import PermissionsEnum = PermissionResponse.PermissionsEnum;

export const AlteGrundbuchmeldungRoutes: Routes = [
  {
    path: 'altegrundbuchmeldung',
    loadChildren: () => routes,
    providers: [AlteGrundbuchmeldungListResolver]
  }
];

const routes: Routes = [
  {
    path: '',
    component: AlteGrundbuchmeldungSucheComponent,
    canActivate: [canActivateAuthorization, canActivateErweiterung],
    data: {
      permissions: [PermissionsEnum.GRUNDBUCH_MELDUNGEN_REGISTER],
      erweiterung: ['ALTE_MELDUNGEN_REGISTER'],
      breadcrumb: 'altegrundbuchmeldung.search.breadcrumb',
      breadcrumbStatus: 'firstLevel'
    }
  },
  {
    path: 'list',
    component: AlteGrundbuchmeldungListComponent,
    canActivate: [canActivateAuthorization, canActivateErweiterung],
    data: {
      permissions: [PermissionsEnum.GRUNDBUCH_MELDUNGEN_REGISTER],
      erweiterung: ['ALTE_MELDUNGEN_REGISTER'],
      breadcrumb: 'shared.breadcrumb.list',
      breadcrumbStatus: 'secondLevel'
    },
    resolve: {
      entries: AlteGrundbuchmeldungListResolver
    }
  }
];
